import React from 'react';

import { BuildIcon } from '../utils';

const IconInfo16 = (props) => (
  <BuildIcon {...props} viewBox="0 0 16 16" width="16" height="16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0166 9.17217L6.01514 9.17217L6.01514 7.97217L10.0166 7.97217L10.0166 9.17217Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0166 11.5403L6.01514 11.5403L6.01514 10.3403L10.0166 10.3403L10.0166 11.5403Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.99997 0.600098V15.4001H13V3.74538L9.74238 0.600098L2.99997 0.600098ZM4.19997 14.2001V1.8001L8.59995 1.80009V5.40014H11.8V14.2001H4.19997ZM11.7434 4.20014L9.79994 2.32373V4.20014H11.7434Z"
      fill="black"
      fillOpacity="0.9"
    />
  </BuildIcon>
);

export default IconInfo16;
